/**
 * Rol ekranının metinleri.
 *
 * Ayrı dosyada: metin değiştirmek mantık dosyasını açmayı gerektirmesin, ve
 * yeni bir dil eklemek tek yerde bitsin.
 */

import type { TranslationBundle } from '../../shell/bridge.ts';

export const TEXTS: TranslationBundle = {
  en: {
    at_is_firm: 'This account belongs to the firm side. Register with a separate email for the customer side.', at_is_customer: 'This account belongs to the customer side. Register with a separate email for the firm side.',
    role_q: 'How would you like to continue?',
    role_hint: 'This choice is written to your account permanently and cannot be changed later.',
    role_cust: 'I am a customer',
    role_cust_d: 'I upload my documents and invoices; my bookkeeper sees them instantly.',
    role_firm: 'I am the firm',
    role_firm_d: 'I am a bookkeeping office; my team and I manage our clients records.',
    role_back: '← Change choice',
    my_account: 'My Account',
    cust_single: 'A customer account runs with a single user.',
  },
};

/** Yönetici profilinin adı — müşteri tarafında sistem verir, kullanıcı değiştiremez. */
export const MANAGER_NAMES: Record<string, string> = {
  en: 'General Manager',
};
